import React from 'react'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { Box } from '@smooth-ui/core-sc'
import { Link } from 'react-router-dom'

import trackGMT from 'helpers/gtm'
import { A, P, SpinnerButton } from 'components/Elements/index'
import { QUERY_LIST_FAVORITES, MUTATION_ADD_FAVORITE } from 'helpers/queries'

import routeConfig from 'routeConfig'

const AddFavorite = ({ postId, title }) => {
  const { data, loading } = useQuery(QUERY_LIST_FAVORITES)
  const [addFavorite, { loading: addLoading }] = useMutation(
    MUTATION_ADD_FAVORITE
  )
  const onAdd = event => {
    event.preventDefault()
    trackGMT({
      event: 'custom',
      category: 'Video',
      action: 'Add favorite',
      label: title
    })
    const id = new Date().getTime()
    addFavorite({
      variables: { postId, title },
      refetchQueries: [{ query: QUERY_LIST_FAVORITES }],
      optimisticResponse: {
        __typename: 'Mutation',
        addFavorite: {
          id,
          postId,
          title,
          created: id,
          __typename: 'Favorite'
        }
      },
      update(cache, { data }) {
        const current = cache.readQuery({
          query: QUERY_LIST_FAVORITES
        })
        cache.writeQuery({
          query: QUERY_LIST_FAVORITES,
          data: {
            listFavorites: [
              ...current.listFavorites,
              {
                id,
                postId,
                title,
                created: id,
                __typename: 'Favorite'
              }
            ]
          }
        })
      }
    })
  }
  if (loading && !data) {
    return null
  }
  if (!data || !data.listFavorites) {
    return null
  }
  const inFavorite = data.listFavorites.find(item => item.postId === postId)
  return (
    <Box>
      {inFavorite ? (
        <P>
          I dine{' '}
          <A as={Link} to={routeConfig.mypageFavorites}>
            favoritter
          </A>
        </P>
      ) : (
        <SpinnerButton
          working={addLoading}
          onClick={onAdd}
          text="Legg i favoritter"
        />
      )}
    </Box>
  )
}

export default AddFavorite
